
import { AxiosResponse } from 'axios'
import { defineComponent } from 'vue'
import { FilterOperator } from 'primevue/api'
import { filterDefault } from '@/helpers/commons/filterHelper'
import lovsManagementDatasetDescriptor from './LovsManagementDatasetDescriptor.json'
import Dialog from 'primevue/dialog'
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'

export default defineComponent({
    name: 'lovs-management-dataset',
    components: { Dialog, DataTable, Column },
    props: { dataset: Object },
    data() {
        return {
            lovsManagementDatasetDescriptor,
            dirty: false,
            showDatasetsDialog: false,
            datasets: [] as any,
            selectedDataset: {} as any,
            columns: lovsManagementDatasetDescriptor.columns,
            filters: {
                global: [filterDefault],
                label: {
                    operator: FilterOperator.AND,
                    constraints: [filterDefault]
                },
                name: {
                    operator: FilterOperator.AND,
                    constraints: [filterDefault]
                },
                description: {
                    operator: FilterOperator.AND,
                    constraints: [filterDefault]
                },
                owner: {
                    operator: FilterOperator.AND,
                    constraints: [filterDefault]
                },
                scope: {
                    operator: FilterOperator.AND,
                    constraints: [filterDefault]
                }
            } as Object
        }
    },
    async created() {
        this.loadDataset()
        await this.loadDatasets()
    },
    watch: {
        dataset() {
            this.loadDataset()
        }
    },
    methods: {
        async loadDatasets() {
            await this.$http.get(process.env.VUE_APP_RESTFUL_SERVICES_PATH + '1.0/datasets/datasetsforlov/').then((response: AxiosResponse<any>) => (this.datasets = response.data))
        },
        loadDataset() {
            this.selectedDataset = { ...this.dataset }
        },
        onSave() {
            this.showDatasetsDialog = false
            this.$emit('selected', this.selectedDataset)
        }
    }
})
